import { useState } from "react"
import { RiMailLine, RiCloseLine } from "@remixicon/react"

export default function ContactButton() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      {/* Floating Contact Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-8 right-8 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-[#003566] to-[#001d3d] text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
        aria-label="Contact Us"
      >
        <RiMailLine className="size-6 group-hover:scale-110 transition-transform duration-300" />
      </button>

      {/* Modal Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
          onClick={() => setIsOpen(false)}
        >
          {/* Modal Content */}
          <div
            className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 z-10 flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
              aria-label="Close"
            >
              <RiCloseLine className="size-6 text-gray-600" />
            </button>

            {/* Header */}
            <div className="bg-gradient-to-r from-[#003566] to-[#001d3d] p-6 text-center">
              <h2 className="text-2xl font-semibold text-white">Contact Us</h2>
              <p className="mt-2 text-gray-200">
                Fill out the form below and we'll get back to you shortly.
              </p>
            </div>

            {/* Iframe Container */}
            <div className="w-full h-[533px] overflow-auto">
              <iframe
                className="airtable-embed w-full h-full"
                src="https://airtable.com/embed/appR9wgPnwfYKJA5f/paggPy4D0AGcjia4c/form"
                frameBorder="0"
                style={{ background: "transparent", border: "none" }}
                title="Contact Form"
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
